import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs/Subscription";
import Swal from 'sweetalert2';
import { environment } from "../../environments/environment";
import { BindMdl } from "../../Models/BindMdl";
import { Attachments, mdlCity, mdlClaimBindInfoRes, mdlClaimIntimationAddReq, mdlClaimIntimationAddRes, mdlClaimIntimationListRes, mdlGetClaimsListReq } from "../../Models/Claims";
import { ClaimAttachmentsMdl, mdlClaimAttachments } from "../../Models/CompAttachmentsMdl";
import { CustomerProfileMdl, ProfileReqMdl } from "../../Models/CustomerProfileMdl";
import { mdlGetClaimStatusRes } from "../../Models/mdlGetClaimStatusRes ";
import { mdlPayloadRequest } from "../../Models/mdlPayloadRequest";
import { mdlPayloadResponse } from "../../Models/mdlPayloadResponse";
import { MotorProposal } from "../../Models/MotorProposal";
import { MotorStatusMdl } from "../../Models/MotorStatusMdl";
import { restURL } from "../../Models/restURL";
import { LanguageService } from "../../Services/languageService";
import { motorProposalService } from "../../Services/motorProposalService";
import { userService } from "../../Services/userService";
declare let $: any;

@Component({
  selector: "ClaimsIntimation",
  templateUrl: "./ClaimsIntimation.html",
  styleUrls: ["./ClaimsIntimation.css"],
})


export class ClaimsIntimation {
  public pnlLoadingPanel: boolean = true;
  public Lang: any;
  public LngSubscription: Subscription;
  // public ObjClaimAddReq: mdlClaimAddReq = new mdlClaimAddReq();
  public bindObj: BindMdl = new BindMdl();
  public profileObj: CustomerProfileMdl = new CustomerProfileMdl();
  public profileReq: ProfileReqMdl = new ProfileReqMdl();

  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();
  public ObjGetClaimsReq: mdlGetClaimsListReq = new mdlGetClaimsListReq();
  public ObjGetClaimsRes: Array<mdlClaimIntimationListRes> = new Array<mdlClaimIntimationListRes>();
  public ClaimStatusRes :mdlGetClaimStatusRes=new mdlGetClaimStatusRes();

  public IsSubmitted: boolean = false;
  public isSubmitted: boolean = true;
  public VDType: string = "2";
  public prObj: MotorProposal = new MotorProposal();
  public ObjClaimAddReq: mdlClaimIntimationAddReq = new mdlClaimIntimationAddReq;
  public objBindInfoRes: mdlClaimBindInfoRes = new mdlClaimBindInfoRes;
  today: any;
  addClaims: any;
  ObjClaimAddRes: mdlClaimIntimationAddRes = new mdlClaimIntimationAddRes;;
  public Attachments: Array<Attachments> = new Array<Attachments>();
  public headers = new HttpHeaders();
  public statusObj: MotorStatusMdl = new MotorStatusMdl();
  public BankNameEn: any;
  public BankNameAr: any;
  public pdfUrl: any;
  public ClaimDetails: any;
  public ClaimDetailsModal: boolean; Images: any
  public Claimattachments: ClaimAttachmentsMdl = new ClaimAttachmentsMdl();

  public Moroor: boolean = false; public Najm: boolean = false;
  public UploadResult: any = false;
  public isShowLoading: boolean = false; public RegNo: any;public ShowClaimStatus:boolean = false;

  public constructor(private Decriptsrvc: motorProposalService, private EncriptService: motorProposalService, private userInfo: userService, private router: Router, public Translate: TranslateService, private http: HttpClient, private lngService: LanguageService, public url: restURL) {

    this.LngSubscription = this.lngService.grtLng().subscribe(Lng => {
      this.Lang = Lng;
    });
    if (sessionStorage.getItem("Language") != null) {
      this.Lang = sessionStorage.getItem("Language");
    }
    else {
      this.Lang = "en";
    }
    this.ObjClaimAddReq.Lang=this.Lang;
    this.ObjClaimAddReq.ProductCode = "";
    this.ObjClaimAddReq.AccidentDate = (new Date().toISOString().split('T')[0]).toString();
    this.today = new Date().toJSON();
    this.ObjGetClaimsReq.RegNo = sessionStorage.getItem("RegNo");
    this.BindInfo();
    this.GetClaimsIntimationsList();
  }



  BindInfo() {
    this.isShowLoading = true;

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.ObjGetClaimsReq.RegNo));

    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Claims/ClaimsBindInfo", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then((result) => {

      //New Line Start
      this.objPayloadResponse = result;
      this.objBindInfoRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End
      if (this.objBindInfoRes.StatusCode == "F") {
        Swal(this.objBindInfoRes.StatusDesc, "", "error")
        return;
      }
    },(error) => {
      this.userInfo.checkTokenStatus(error);
      this.isShowLoading = false;
    });
  }

  GetClaimsIntimationsList() {

    this.ObjGetClaimsReq.RegNo = sessionStorage.getItem("RegNo");
    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(sessionStorage.getItem("RegNo")));
    this.isShowLoading = true;
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "Claims/GetClaimIntimationListNew", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then((result) => {
      this.isShowLoading = false;
      this.objPayloadResponse = result;
      this.ObjGetClaimsRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
    },
    (error) => {
      this.userInfo.checkTokenStatus(error);
      this.isShowLoading = false;
    });
  }


  async SubmitClaim(valid: any) {

    try {
      //this.presentAlert(JSON.stringify(this.Attachments))
      this.IsSubmitted = true;
      
      if (!valid.valid) {
        let Contorl: string;
        let ElementKey: string;
        Object.keys(valid.controls).forEach(key => {
          if (valid.controls[key].errors != undefined) {
            if (Contorl == null || Contorl == undefined) {
              Contorl = key.substring(3, key.length);
              ElementKey = key;
            }
          }
        });
      }
      if (!valid.valid) {
        return;
      }
      
    
      this.ObjClaimAddReq.Lang=this.Lang ;
      var EffectiveDate = new Date(this.ObjClaimAddReq.AccidentDate);
      var currentDate: Date = new Date();
      if (EffectiveDate > currentDate) {
        Swal("AccidentDate should be less than or equal to today's date.", "", "error")
        return;
      }
      if (this.Attachments == null || this.Attachments.length == 0) {
        Swal("Please Attach All Mandatory Documents", "", "error")
        return;
      }

      if (this.objBindInfoRes.ClaimAttachmentList.filter(t => t.ProductCode == this.ObjClaimAddReq.ProductCode && t.ClaimTypeCode == this.ObjClaimAddReq.ClaimTypeCode && t.IsMandatory == true && (t.ImageList == null || t.ImageList.length == 0)).length > 0) {

        Swal("Attachment Is Missing: " + this.objBindInfoRes.ClaimAttachmentList.filter(t => t.ProductCode == this.ObjClaimAddReq.ProductCode && t.ClaimTypeCode == this.ObjClaimAddReq.ClaimTypeCode && t.IsMandatory == true && (t.ImageList == null || t.ImageList.length == 0))[0].AttachmentDesc, "", "error")
        return;
      }
      this.isShowLoading = true;

      this.ObjClaimAddReq.Attachments = this.Attachments;
      this.ObjClaimAddReq.UserId = "331";
      this.ObjClaimAddReq.Channel = "B2C"
      this.ObjClaimAddReq.RegNo = sessionStorage.getItem("RegNo");
      this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.ObjClaimAddReq));

      await this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Claims/AddClaimIntimation", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then((result) => {

        //New Line Start
        this.objPayloadResponse = result;
        this.ObjClaimAddRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
        //NewLine End


        if (this.ObjClaimAddRes.StatusCode == "S") {
          Swal("Your claim registered successfully, with Claim Submission No" + " " + this.ObjClaimAddRes.ClaimIntimationNo, "", "success");
          this.Clear();
          return;
        } else {
          Swal(this.ObjClaimAddRes.StatusDesc, "", "error")
          return;
        }
      },(error) => {
        this.userInfo.checkTokenStatus(error);
        this.isShowLoading = false;
      });
    }
    catch { }
    finally {
      this.isShowLoading = false;
    }

  }



  removefile(type: any) {
    if (type == "Accident") {
      // this.AccReportFileName = "";
      this.ObjClaimAddReq.AccReportFileName = "";
      this.Attachments.splice(0, 1);
    } else {
      // this.IBANFileName = "";
      this.ObjClaimAddReq.IBANFileName = "";
      this.Attachments.splice(1, 1);
    }
  }

  ValidateSpecialChar(event: any) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }


  ClaimChange(val: any) {

    if (val == "1") {
      this.Moroor = true;
      this.Najm = false;
    }
    else if (val == "2") {
      this.Najm = true;
      this.Moroor = false;
    }
    else {
      this.Moroor = false;
      this.Najm = false;
    }
  }


  validText(evt: any) {
    var regx: any = /^[a-zA-Z]*$/
    if (regx.test(evt.key)) {
      return true;
    }
    return false;
  }

  validNumber(evt: any) {
    var regx: any = /[0-9]/
    if (regx.test(evt.key)) {
      return true;
    }
    return false
  }

  async OnFileUpload(event: any, FileType: any) {
    try {
      this.isShowLoading = true;
      if (event.target.files && event.target.files[0]) {
        var fsize = event.target.files[0].size / 1048576;
        var fileName = event.target.files[0].name;
        var fileExt = fileName.substring(fileName.lastIndexOf(".") + 1);
        if (fileExt.toString().toUpperCase() != "JPG" && fileExt.toString().toUpperCase() != "JPEG" && fileExt.toString().toUpperCase() != "PNG" && fileExt.toString().toUpperCase() != "PDF") {
          Swal("Please select valid File Type", "", "error")
          return;
        }
        var isvalid = "";
        if (fsize > 10) {
          Swal("File Size Should not exceed 10 MB", "", "error")
          return;
        }
        let ImgLisngth: number = 0;
        if (this.objBindInfoRes.ClaimAttachmentList.filter(t => t.AttachmentShortDesc == FileType)[0].ImageList != null) {
          ImgLisngth = this.objBindInfoRes.ClaimAttachmentList.filter(t => t.AttachmentShortDesc == FileType)[0].ImageList.length;
        }
        //<<<<<Uploading To Server Start>>>>>>>>   
        var param = environment;              
        if (!param.St.StatusDesc) {
            throw new Error("Encryption key is not initialized.");
        }

        var UserName = this.EncriptService.EncriptPayload(JSON.stringify(param.Master.Code));
        var Password = this.EncriptService.EncriptPayload(JSON.stringify(param.Master.Description));
        
        this.isShowLoading = false;
        var fd = new FormData();
        fd.append("file", event.target.files[0]);
        fd.append("fileType", FileType + "_" + ImgLisngth.toString());
        fd.append("attchmentId", this.objBindInfoRes.AttachmentId)
        this.headers = new HttpHeaders();
        this.headers.delete('Content-Type');
        this.headers.set('enctype', "multipart/form-data");
        this.headers = this.headers.append('Accept-Encoding', 'gzip');
        this.headers = this.headers.append('apiToken', "");
        this.headers = this.headers.append("Authorization", "Basic " + btoa(UserName + ':' + Password));
        await this.http.post<MotorStatusMdl>(this.url.baseURL + "/Upload/SaveAttachmentsClaims", fd, { headers: this.headers }).toPromise().then(
          async (res) => {
            if (res.StatusCode != "S") {
              Swal(res.StatusDesc, "", "info")
              return;
            }
          },
          (error) => {
            Swal(error.message, "", "error")
          });
        //<<<<<Uploading To Server End>>>>>>>>

        //<<<<For Image Preview Start>>>>>>>>>>>
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event) => {
          if (fsize < 10) {
            let target = <any>event.target;
            let image = target.result;

            let ImgListLength: number = 0;
            let MaxImageListLength: number = this.objBindInfoRes.ClaimAttachmentList.filter(t => t.AttachmentShortDesc == FileType)[0].MaxImageListLength - 1;

            if (this.objBindInfoRes.ClaimAttachmentList.filter(t => t.AttachmentShortDesc == FileType)[0].ImageList != null) {
              ImgListLength = this.objBindInfoRes.ClaimAttachmentList.filter(t => t.AttachmentShortDesc == FileType)[0].ImageList.length;
            }
            else {
              let ImageList = new Array<Attachments>();
              this.objBindInfoRes.ClaimAttachmentList.filter(t => t.AttachmentShortDesc == FileType)[0].ImageList = ImageList;
            }
            if (ImgListLength > MaxImageListLength) {
              Swal("Document Limit Exceeds", "", "error")
              return;
            }
            let objAtach: Attachments = new Attachments();

            if (fileExt.toString().toUpperCase() == "PDF") {
              objAtach.Attachment = this.url.DocumentURL + "Downloads/SamplePdfImage.PNG";
            }
            else {
              objAtach.Attachment = image;
            }
            this.objBindInfoRes.ClaimAttachmentList.filter(t => t.AttachmentShortDesc == FileType)[0].ImageList.push(objAtach)
            this.AddToAttachList(this.objBindInfoRes.AttachmentId + "_" + FileType + "_" + ImgListLength.toString() + "." + fileExt, FileType)

          }
        }
        //<<<<For Image Preview End>>>>>>>>>>>
      }

    }
    catch { }
    finally {
      this.isShowLoading = false;
    }


  }

  AddToAttachList(AttchName: any, FileType: any) {
    if (this.Attachments.length > 0) {
      if (this.Attachments.findIndex(t => t.Attachment == AttchName) > -1) {
        this.Attachments.splice(this.Attachments.findIndex(t => t.Attachment == AttchName), 1);
      }
    }
    let newattach: Attachments = new Attachments();
    newattach.Attachment = AttchName;
    newattach.ComplaintId = FileType;
    this.Attachments.push(newattach)

  }

  SetProduct(ProductCode: any) {
    this.ObjClaimAddReq.ProductCode = ProductCode;
  }

  DownloadClaimForm() {
    if (this.ObjClaimAddReq.ProductCode == '5515') {
      this.pdfUrl = `${this.url.DocumentURL}Downloads//ClaimFormTP.pdf`
    }
    else if (this.ObjClaimAddReq.ProductCode == '5520') {
      this.pdfUrl = `${this.url.DocumentURL}Downloads//ClaimFormOD.pdf`
    }
    window.open(this.pdfUrl, "_blank");

  }

  FilterClaimAttachment(objClaimAttachmentList: Array<mdlClaimAttachments>) {
    let result: Array<mdlClaimAttachments> = new Array<mdlClaimAttachments>();
    result = objClaimAttachmentList;
    return result = result.filter(t => t.ProductCode == this.ObjClaimAddReq.ProductCode && t.ClaimTypeCode == this.ObjClaimAddReq.ClaimTypeCode);
  }

  ImageRows(objImgList: Array<Attachments>) {
    let result: Array<Attachments> = new Array<Attachments>();
    result = objImgList;
    return Array.from(Array(Math.ceil(result.length / 2)).keys());
  }

  Removefile(FileType: any, Index: any) {
    this.objBindInfoRes.ClaimAttachmentList.filter(t => t.AttachmentShortDesc == FileType)[0].ImageList.splice(Index, 1)
  }

  ViewClaim(value) {
    this.ClaimDetails = value;
    this.ClaimDetailsModal = true;
  }
  HideClaimDetailsModal() {
    this.ClaimDetailsModal = false;
  }

  DownloadAttchments(item) {
    window.open( item.Attachment, "_blank");
  }
  Clear() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  GetCalimStatus(value) {
    try{
      let Req = {
        PolicyNo: value.PolicyNo,
        InsuredIdNo: value.IDNumber,
        ClaimIntimationNo: value.ClaimIntimationNo
      }
      this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(Req));
      this.isShowLoading = true;
      this.http.post<mdlPayloadResponse>(this.url.baseURL + "Claims/GetClaimStatus", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then((result) => {
        this.isShowLoading = false;
        this.objPayloadResponse = result;
        this.ClaimStatusRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
        this.ShowClaimStatus = true;
      }, (error) => {
        
      });
    }
    catch{}
    finally{
      this.isShowLoading = false;
    }
    
  }
  HideClaimStatus(){
    this.ShowClaimStatus = false;
  }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/ClaimsIntimation/ClaimsIntimation.ts